<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form @submit.prevent="onSubmit">
        <v-card-title>
          <span class="headline">
            {{ mess.dialog_select_on_company_title }}
          </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div
                  ref="map"
                  style="width: 100%; height: 300px; background: #c9c9c9"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions style="padding: 0 24px 16px">
          <v-spacer />

          <v-btn color="primary" depressed dark @click="dialog = false">
            {{ mess.dialog_base_button_close }}
          </v-btn>

          <v-btn color="primary" depressed dark type="submit">
            {{ mess.dialog_base_button_save }}
          </v-btn>
        </v-card-actions>

        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  name: "CompanyOnMapDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    address: null,
    dialog: false,
    map: null,
    marker: null,
    loader: new Loader({
      apiKey: "AIzaSyCFTuQHDD8F6sxreiYVMFRsEWoEDWCXofI",
      version: "weekly",
      language: "en"
    })
  }),
  computed: {
    mapContainer() {
      return this.$refs["map-wrapper"].$el;
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;

      if (val && !this.map) {
        this.initMap();
      }
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  methods: {
    getAddress(lat = 0, lng = 0) {
      // Создаем экземпляр геокодера
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder();

      // Создаем объект LatLng из координат
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);

      // Используем метод geocode для получения адреса
      geocoder.geocode({ location: latLng }, (results, status) => {
        // eslint-disable-next-line no-undef
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            this.address = results[0].formatted_address;
          } else {
            console.debug("Адрес не найден");
          }
        } else {
          console.debug("Ошибка геокодирования: " + status);
        }
      });
    },
    handleMapClick(event) {
      const latLng = event.latLng;

      // Если маркер уже существует, перемещаем его на новую точку
      if (this.marker) {
        this.marker.setPosition(latLng);
      } else {
        // Создаём новый маркер в точке клика
        // eslint-disable-next-line no-undef
        this.marker = new google.maps.Marker({
          position: latLng,
          map: this.map
        });
      }

      this.getAddress(latLng.lat(), latLng.lng());
    },
    async initMap() {
      this.loader.load().then(async () => {
        // eslint-disable-next-line no-undef
        const { Map } = await google.maps.importLibrary("maps");

        this.map = new Map(this.$refs.map, {
          center: { lat: 61.49806090959257, lng: 23.75323191521061 },
          zoom: 8
        });

        this.map.addListener("click", (event) => {
          this.handleMapClick(event);
        });
      });
    },
    onSubmit() {
      if (this.marker && this.address) {
        const position = this.marker.getPosition();
        const coords = [position.lat(), position.lng()];

        this.$emit("set-address", {
          coords,
          address: this.address
        });
      }

      this.dialog = false;
    }
  }
};
</script>

<style lang="scss"></style>
